import { COMMITTEEURL } from "helpers/constant";
import { callApi } from "Apis";

export async function committeeList(data) {
  try {
    const response = await callApi({ url: COMMITTEEURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function addCommittee(data) {
  try {
    const response = await callApi({ url: COMMITTEEURL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getCommitteeById(id) {
  try {
    const response = await callApi({ url: COMMITTEEURL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}
export async function updateCommittee(data) {
  try {
    const response = await callApi({ url: COMMITTEEURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function deleteCommitteeById(id) {
  try {
    const response = await callApi({ url: COMMITTEEURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (err) {
    throw err;
  }
}
